const headerSelector = (state) => state.header;
const sidebarOpenSelector = (state) => headerSelector(state).sidebarOpen;

export { sidebarOpenSelector };
